import type {
	CreateMapInput,
	EffectiveAccessRole,
	Layer,
	MapSummary,
	UpdateMapInput,
} from "shared";
import { api } from "./client";

export type MapDetailResponse = {
	map: MapSummary;
	layers: Layer[];
	access: { role: EffectiveAccessRole };
};

export const mapsApi = {
	list: () => api.get<{ maps: MapSummary[] }>("/maps"),
	get: (id: string) => api.get<MapDetailResponse>(`/maps/${id}`),
	create: (input: CreateMapInput) =>
		api.post<{ map: MapSummary }>("/maps", input),
	update: (id: string, input: UpdateMapInput) =>
		api.patch<{ map: MapSummary }>(`/maps/${id}`, input),
	remove: (id: string) => api.del<{ ok: boolean }>(`/maps/${id}`),
	importGeojson: (id: string, geojson: unknown) =>
		api.post<{ layers: Layer[]; entriesCreated: number }>(
			`/maps/${id}/import/geojson`,
			{ geojson },
		),
};
